import { IconAlarm } from '@assets/images/main/index';
import {
  CameraFunctions1D,
  CameraFunctions1M,
  CameraFunctions1T,
  CameraFunctions2D,
  CameraFunctions2M,
  CameraFunctions2T,
  CameraFunctions3D,
  CameraFunctions3M,
  CameraFunctions3T,
  CameraFunctions4D,
  CameraFunctions4M,
  CameraFunctions4T,
  CameraFunctions5D,
  CameraFunctions5M,
  CameraFunctions5T,
  CameraFunctions6D,
  CameraFunctions6M,
  CameraFunctions6T,
  CameraFunctions7D,
  CameraFunctions7M,
  CameraFunctions7T,
} from '@assets/images/main/camera/main/functions';
import { IconEdgeOff, IconEdgeOn, IconOsOff, IconOsOn, IconServerOff, IconServerOn } from '@assets/images/main/icon';
import {
  cameraBannerBg,
  cameraBannerProduct,
  cameraScreenshot1D,
  cameraScreenshot1M,
  cameraScreenshot1T,
  cameraScreenshot2D,
  cameraScreenshot2M,
  cameraScreenshot2T,
  cameraScreenshot3D,
  cameraScreenshot3M,
  cameraScreenshot3T,
} from '@assets/images/main/camera';
import { IconBlueCircle, IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';

import { screenViewCamera1, screenViewCamera2, screenViewCamera3, screenViewCamera4, screenViewCamera5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgGridLine } from '@assets/images/icon/svg/grid-line.svg';
import { ReactComponent as SvgLocationLine } from '@assets/images/icon/svg/location-line.svg';
import { ReactComponent as SvgChartLine } from '@assets/images/icon/svg/chart-line.svg';
import { ReactComponent as SvgPencilLine } from '@assets/images/icon/svg/pencil-line.svg';
import { ReactComponent as SvgAi } from '@assets/images/icon/svg/ai.svg';

export default {
  mainPage: {
    product: {
      title: 'Explore Product Lineup',
      desc: 'Discover our innovative location tracking products.',
      outdoor: {
        title: 'Outdoor Camera',
        desc: 'Detect and manage the location and abnormal behavior<br/>of various objects such as people and vehicles through camera footage.',
      },
      indoor: {
        title: 'Indoor Camera',
        desc: 'Analyze indoor movement paths<br/>of individuals using video footage.',
      },
    },
  },

  banner: {
    title: 'Real-time location tracking with video only,<br/>automatically tracking the movements of people and vehicles.',
    desc: 'Easily track objects like people and vehicles using AI Server and AI Edge,<br/>and integrate seamlessly with ORBRO OS.',

    schemeTitle: 'Camera system recommended by ORBRO.',
    schemeDesc: 'Need help deciding?',
    schemeDesc2: 'Contact us at<br/>and our access control experts will assist you.',
    phone: '1522-9928',

    bgImg: cameraBannerBg,
    productImg: cameraBannerProduct,
  },

  bannerData: [
    {
      icon: IconEdgeOn,
      iconInv: IconEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/en/camera/edge',
    },
    {
      icon: IconServerOn,
      iconInv: IconServerOff,
      image: '',
      iconText: 'ORBRO AI Server',
      sub: 'New',
      link: '/en/camera/server',
    },
  ],
  screenView: {
    title: 'Real-Time Video, Instant Insights',
    data: [
      { icon: SvgGridLine, text: 'Multi-Video Streaming', img: screenViewCamera1 },
      { icon: SvgLocationLine, text: 'Location Data Conversion', img: screenViewCamera2 },
      { icon: SvgChartLine, text: 'Video Insight', img: screenViewCamera3 },
      { icon: SvgPencilLine, text: 'Prompt Feature Support', img: screenViewCamera4 },
      { icon: SvgAi, text: 'Context Recognition Engine', img: screenViewCamera5 },
    ],
  },
  screenShot: [
    {
      title: 'Track locations with video only—no tags needed',
      desc: 'When people or vehicles are detected by cameras, their locations appear on the map in real time.<br/>No tags required—movement is tracked via video and visualized directly on the layout.',
      img: {
        desktop: cameraScreenshot1D,
        tablet: cameraScreenshot1T,
        mobile: cameraScreenshot1M,
      },
    },
    {
      title: 'No need to install new cameras',
      desc: 'If your existing infrastructure supports RTSP or ONVIF, you can start AI-based video tracking right away.<br/>Setup is simple, and object recognition models can be customized for each camera.',
      img: {
        desktop: cameraScreenshot2D,
        tablet: cameraScreenshot2T,
        mobile: cameraScreenshot2M,
      },
    },
    {
      title: 'AI understands and explains actions in space',
      desc: 'AI interprets real-world scenarios and delivers insights.<br/>It detects hazardous situations, monitors work status, automates access control, and more.',
      img: {
        desktop: cameraScreenshot3D,
        tablet: cameraScreenshot3T,
        mobile: cameraScreenshot3M,
      },
    },
  ],

  video: {
    title: 'ORBRO AI Camera System',
    desc: [
      { text: 'Collects and analyzes location data of people and vehicles in outdoor areas.' },
      { text: 'Identifies the movement paths of people indoors.' },
      { text: 'Integrates with existing camera infrastructure such as public CCTVs.' },
      { text: 'Allows easy addition of new cameras as needed.' },
    ],
  },

  func: {
    title: 'Explore Camera Functions',
    desc: 'Discover the diverse capabilities of our camera system.',

    data: [
      {
        img: IconBlueShield,
        title: 'Permissions & Group Management',
        desc: 'Manage user/admin roles and access rights for feature control.\nOrganize users into groups by department or team.',
      },
      {
        img: IconAlarm,
        title: 'Condition Alerts (5 Levels)',
        desc: 'Set up five alert levels based on specific conditions.\nQuickly detect anomalies and take appropriate action.',
      },
      {
        img: Icon3dMeter,
        title: 'Zone Monitoring',
        desc: 'Define zones on the map and monitor people/assets entering those areas in real time.',
      },
      {
        img: Icon3dCycle,
        title: 'Reverse Direction Detection',
        desc: 'Automatically detects movement opposite to expected path direction and issues alerts.',
      },
      {
        img: Icon3dDetect,
        title: 'Entry/Exit Detection',
        desc: 'Automatically detects entry and exit in access zones.\nRecords and analyzes stay duration and history.',
      },
      {
        img: Icon3d3d,
        title: 'Device Search & Status Monitoring',
        desc: 'Easily monitor all Tag and Anchor devices including battery and connection status.',
      },
    ],
  },

  functions: {
    title: 'Digital Twin Location Tracking with AI Technology',
    desc: 'ORBRO AI camera systems provide high accuracy and reliability.<br/>They track and analyze the locations of people and vehicles indoors and outdoors to deliver actionable insights.',

    line: 3,
    card: [
      {
        size: '3',
        tag: 'Key Feature',
        title: 'Objects detected by video<br/>visualized in real time on the map',
        label: 'Admin',
        img: {
          desktop: CameraFunctions1D,
          tablet: CameraFunctions1T,
          mobile: CameraFunctions1M,
        },
      },
      {
        color: '#fff',
        size: '1',
        tag: 'Mobile Service',
        title: 'Mobile usability<br/>for all spaces',
        label: 'Common',
        img: {
          desktop: CameraFunctions2D,
          tablet: CameraFunctions2T,
          mobile: CameraFunctions2M,
        },
      },
      {
        size: '2',
        tag: 'Legacy CCTV Compatible',
        title: 'Compatible with<br/>all video sources',
        label: 'Admin',
        img: {
          desktop: CameraFunctions3D,
          tablet: CameraFunctions3T,
          mobile: CameraFunctions3M,
        },
      },
      {
        size: '2',
        tag: 'Person/Vehicle Detection',
        title: 'High recognition<br/>for people and vehicles',
        label: 'Admin',
        img: {
          desktop: CameraFunctions4D,
          tablet: CameraFunctions4T,
          mobile: CameraFunctions4M,
        },
      },
      {
        size: '2',
        tag: 'On-site Server Setup',
        title: 'Robust and<br/>secure infrastructure',
        label: 'On-Premise',
        img: {
          desktop: CameraFunctions5D,
          tablet: CameraFunctions5T,
          mobile: CameraFunctions5M,
        },
      },
      {
        size: '1',
        tag: 'Enterprise Parking, etc.',
        title: 'Scalable setup<br/>for large parking lots',
        label: 'Enterprise',
        img: {
          desktop: CameraFunctions6D,
          tablet: CameraFunctions6T,
          mobile: CameraFunctions6M,
        },
      },
      {
        size: '3',
        tag: 'Dashboard',
        title: 'Data insight,<br/>data-driven decisions',
        label: 'Admin',
        img: {
          desktop: CameraFunctions7D,
          tablet: CameraFunctions7T,
          mobile: CameraFunctions7M,
        },
      },
    ],
  },

  FAQ: [
    {
      title: 'How does ORBRO’s video-based tracking system work?',
      description:
        'Video footage from installed cameras is analyzed by AI to recognize people and vehicles in real time.<br/>Their positions are calculated and visualized on a map via ORBRO OS.',
    },
    {
      title: 'What is the main difference between ORBRO Edge AI and AI Server?',
      description:
        'ORBRO Edge AI is a standalone device that handles both AI analysis and location tracking.<br/>AI Server analyzes footage from multiple cameras and must be used with ORBRO Server.',
    },
    {
      title: 'Can it work with existing CCTVs?',
      description: 'Yes. Any camera that supports RTSP or ONVIF protocols can be integrated with our system.',
    },
    {
      title: 'Can it be used without a server?',
      description: 'Yes. ORBRO Edge AI can operate independently without a server.<br/>However, AI Server requires integration with ORBRO Server.',
    },
    {
      title: 'Is video tracking better than BLE/UWB?',
      description:
        'It depends on the use case.<br/>Video tracking works without tags but has a limited field of view,<br/>while RF-based methods work without line-of-sight but require tags.<br/>ORBRO supports combining both for optimal results.',
    },
    {
      title: 'Is video data stored? What about privacy concerns?',
      description:
        'By default, AI only analyzes video without storing it. Only location data is saved.<br/>If storage is needed, encryption and access controls are available.',
    },
    {
      title: 'Can only people be detected?',
      description: 'People are the default target. However, with custom settings, vehicles, equipment, and safety gear (e.g., helmets) can also be detected.',
    },
    {
      title: 'Can I receive real-time alerts?',
      description: 'Yes.<br/>You can set conditions (e.g., entering a zone, no detection) and receive real-time notifications via Push, Email, or Webhook.',
    },
  ],
};
